"use client";

import BriefingFormShell from "../../_shared/components/BriefingFormShell";
import RequirementsPackage from "./package/RequirementsPackage";
import { useRequirementsPackage } from "./package/useRequirementsPackage";
import { DASHBOARD_BRIEFING_CONFIG } from "../config";
import type { BriefingFormProps } from "../../_shared/types";
import type { PackageFocus } from "../types";

/**
 * Binds the shared form shell to this briefing's side panel: the live
 * Anforderungspaket derived from the answers. No modal — the package is a
 * text summary that never outgrows its card.
 */
export default function BriefingForm(props: BriefingFormProps<PackageFocus>) {
  const pkg = useRequirementsPackage(props.data.sections, props.answers);
  const { sidePanel } = props.data;

  const header = (compact: boolean) => (
    <p
      className={
        compact
          ? "text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-2.5 flex items-center justify-between gap-2"
          : "text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3 flex items-center justify-between gap-2"
      }
    >
      <span>{sidePanel.title}</span>
      <span className="text-gray-400 font-normal normal-case truncate max-w-[55%] text-right">
        {pkg.title}
      </span>
    </p>
  );

  const caption = (
    <p className="text-[11px] text-gray-400 mt-3 leading-snug">{sidePanel.caption}</p>
  );

  return (
    <BriefingFormShell
      {...props}
      config={DASHBOARD_BRIEFING_CONFIG}
      aside={{
        renderMobile: (focus) => (
          <div className="block lg:hidden mb-5 rounded-xl border border-gray-200 bg-white p-3.5">
            {header(true)}
            <RequirementsPackage pkg={pkg} focus={focus} />
          </div>
        ),
        renderDesktop: (focus) => (
          <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm max-h-[calc(100dvh-13rem)] overflow-y-auto">
            {header(false)}
            {pkg.purpose ? (
              <p className="text-[11px] text-gray-500 italic leading-snug mb-3 line-clamp-2">
                {pkg.purpose}
              </p>
            ) : null}
            <RequirementsPackage pkg={pkg} focus={focus} />
            {caption}
          </div>
        ),
      }}
    />
  );
}
